import Error from 'components/alerts/Error';
import { Info } from 'components/common/form/modules/Info';
import { Text } from 'components/common/form/modules/input/Text';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { isUsernameAvailable, setup, updateUser } from 'components/graphql/queries'

import cloneDeep from 'lodash/cloneDeep';

import React, { useCallback, useEffect, useState } from 'react'

import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { Card } from 'reactstrap';
import { AuthenticationService } from 'services/api/Authentication.service';
import UserDucks from 'stores/ducks/User.duck';

const OneTimeSetup: React.FC<{ [label: string]: any }> = (props: any) => {

    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const [userId] = useState(props.match.params.userId)

    const [username, setUsername] = useState('')
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [lastname, setLastname] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [resetPassword, setResetPassword] = useState(false)

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: setup,
                variables: {
                    userId
                }
            })
            .then((res) => {
                const user = res.data.data.user.isSetupIncomplete;
                if (user !== null) {
                    setEmail(user.email)
                    if (user.lastLoginAt !== undefined && user.lastLoginAt !== null) {
                        setResetPassword(true)
                        setUsername(user.username)
                        setName(user.name)
                        setLastname(user.lastname)
                    }
                } else {
                    window.location.pathname = '/login'
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }, [userId, setName,
        setUsername, setLastname,
        setResetPassword, setEmail])

    const emailIsValid = (e) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
    }

    const createAccount = useCallback(() => {

        setError(false)
        setErrorMessage('')

        // Error checks

        if (password === '' || confirmPassword === '') {
            setError(true)
            setErrorMessage('Fill out password')
            return
        }

        if (!resetPassword && (name === '' || lastname === '' || username === '')) {
            setError(true)
            setErrorMessage('Fill out missing information')
            return
        }

        if (password.length < 8) {
            setError(true)
            setErrorMessage('Password should be at least 8 charactors in length')
            return
        }

        if (password !== confirmPassword) {
            setError(true)
            setErrorMessage('Passwords don\'t match')
            return
        }

        // Check if username is available
        // Then create user
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: isUsernameAvailable,
                variables: {
                    username: username.toLowerCase()
                }
            })
            .then(res => {
                if (res.data.data.user.isUsernameAvailable || resetPassword) {
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: updateUser,
                            variables: {
                                user: {
                                    name,
                                    email: email.toLowerCase(),
                                    username: username.toLowerCase(),
                                    password,
                                    lastname
                                }
                            }
                        })
                        .then(res2 => {
                            if (res2.data.data.user.update) {
                                const AuthService = new AuthenticationService();
                                AuthService.authWithPassword(email.toLowerCase(), password)
                                    .catch(ee => {
                                        window.location.pathname = '/login'
                                    })
                                    .then((res3: any) => {
                                        if (res3.token === undefined) {
                                            setError(true)
                                            setErrorMessage('Unkwown error occurred')
                                            return
                                        }
                                        const newRes = cloneDeep(res3);
                                        delete newRes.events;

                                        props.dispatch(UserDucks.setUser(res3));
                                        // Removing old cookies
                                        props.cookies.remove("user", { path: "/" });
                                        props.cookies.remove("token", { path: "/" });
                                        // Putting new cookies
                                        const date = new Date(); date.setDate(date.getDate() + 7);
                                        props.cookies.set("user", newRes, { path: "/", expires: date });
                                        props.cookies.set("token", res3.token, { path: "/", expires: date });

                                        window.location.pathname = '/campaigns'

                                    });
                            } else {
                                setError(true)
                                setErrorMessage('Something went wrong.')
                                return
                            }
                        })
                        .catch(err => {
                            console.log(err)
                        })
                } else {
                    setError(true)
                    setErrorMessage('Username already in use.')
                    return
                }
            })
            .catch(err => {
                console.log(err)
            })

    }, [name, username, email, password, confirmPassword,
        resetPassword, props, AuthenticationService,
        lastname, setError, setErrorMessage, emailIsValid])

    return <div style={{
        justifyContent: 'center',
        paddingTop: resetPassword ? '50px' : '0px',
        width: '100%', display: 'flex'
    }}>
        <Card style={{ padding: '20px', width: screen.width >= 768 ? '400px' : '100%' }}>
            <div className={'logincard'} style={{ textAlign: 'center', justifyContent: 'center', width: '100%', minWidth: '0px' }}>
                <div>
                    <p style={{ width: '100%' }} />
                    <img src={require('./Dark-logo.png')} style={{ width: '120px' }} />
                </div>
            </div>
            <h5 style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
                {
                    resetPassword ? 'Reset Password' : 'One Time Setup'
                }
            </h5>
            <div style={{ textAlign: 'center', justifyContent: 'center', width: '100%', display: 'flex', paddingBottom: '20px' }}>
                <Info style={{ width: '100%', textAlign: 'center' }}>
                    {email}
                </Info>
            </div>
            {
                resetPassword ? null :
                    <div>
                        <Text
                            label='Username'
                            value={username}
                            onChange={e => setUsername((e.target.value).split(' ').join(''))}
                        />
                        <Text
                            label='First Name'
                            value={name}
                            onChange={e => setName(e.target.value)}
                        />
                        <Text
                            label='Last Name'
                            value={lastname}
                            onChange={e => setLastname(e.target.value)}
                        />
                    </div>
            }
            <Text
                label='Password'
                name='password'
                value={password}
                onChange={e => setPassword(e.target.value)}
            />
            <Text
                name='password'
                label='Confirm Password'
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
            />
            {
                error ?
                    <Error content={errorMessage} /> : null
            }
            <div style={{ width: '100%', paddingTop: '20px', textAlign: 'center' }}>
                <button className='new-button-save' onClick={() => createAccount()}>
                    Save & Login
                </button>
                <p />
            </div>
        </Card>
    </div>
}

// Not really needed
const mapStateToProps = state => {
    return {
        isLoading: UserDucks.isLoading(state),
        isLoggedIn: UserDucks.isAuthenticated(state)
    };
};

const x = withCookies(OneTimeSetup);
export default connect(mapStateToProps)(x)


// WEBPACK FOOTER //
// ./src/pages/auth/login/components/login-form/OneTimeSetup.tsx